const removeMd = require("remove-markdown")
export const getExcerpt = (node: any, removeMarkdown = false) => {
  const excerpt = node.fields.excerpt ?? node.fallbackExcerpt
  return removeMarkdown ? removeMd(excerpt) : excerpt
}
